(function () {
  const STEAL_CODES = ['STEAL5', 'STEAL10', 'STEAL15'];
  let clearingDiscount = false;

  const miniCart = () => document.querySelector('mini-cart');

  function getTierForQty(qty) {
    if (qty >= 4) return 'STEAL15';
    if (qty === 3) return 'STEAL10';
    if (qty === 2) return 'STEAL5';
    return null;
  }

  function getAppliedStealCode(cart) {
    const apps = cart.cart_level_discount_applications || [];
    for (let i = 0; i < apps.length; i++) {
      const title = String(apps[i].title || '').toUpperCase();
      if (STEAL_CODES.includes(title)) return title;
    }
    const codes = cart.discount_codes || [];
    for (let i = 0; i < codes.length; i++) {
      const code = String(codes[i].code || '').toUpperCase();
      if (STEAL_CODES.includes(code)) return code;
    }
    return null;
  }

  /** Clear STEAL code when qty tier changes — user applies the new tier manually. */
  function clearStaleStealDiscount(cart) {
    if (clearingDiscount || !cart) return Promise.resolve();

    const applied = getAppliedStealCode(cart);
    if (!applied) return Promise.resolve();

    const tierCode = getTierForQty(cart.item_count);
    if (tierCode && applied === tierCode) return Promise.resolve();

    clearingDiscount = true;
    const sections = getSectionsPayload();

    return fetch(`${theme.routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        discount: '',
        sections,
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.text())
      .then((responseText) => {
        const parsedState = JSON.parse(responseText);
        if (!parsedState.errors && !parsedState.description) {
          if (!renderCartSections(parsedState)) refreshSudathiSteal();
        }
        return parsedState;
      })
      .catch((e) => console.error('SudathiSteal: clear stale discount failed', e))
      .finally(() => {
        clearingDiscount = false;
      });
  }

  function runStealDiscountSync() {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => clearStaleStealDiscount(cart))
      .finally(() => refreshSudathiSteal());
  }

  function getSectionsPayload() {
    const cart = miniCart();
    if (cart) {
      return cart.getSectionsToRender().map((section) => section.section);
    }
    const itemsEl = document.getElementById('main-cart-items');
    const footerEl = document.getElementById('main-cart-footer');
    if (window.location.pathname.includes('/cart') && itemsEl) {
      const sections = [itemsEl.dataset.id, 'mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
      if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);
      return sections.filter(Boolean);
    }
    return ['mini-cart'];
  }

  function replaceBlock(id, htmlDoc) {
    const current = document.getElementById(id);
    const next = htmlDoc.querySelector('#' + id);
    if (current && next) {
      current.innerHTML = next.innerHTML;
    }
  }

  function refreshSudathiSteal() {
    const progress = document.getElementById('SudathiStealProgress');
    const deals = document.getElementById('SudathiStealDeals');
    if (!progress && !deals) return;

    const sectionIds = [
      ...new Set(
        [progress && progress.getAttribute('data-section-id'), deals && deals.getAttribute('data-section-id')].filter(
          Boolean
        )
      )
    ];
    if (sectionIds.length === 0) sectionIds.push('mini-cart');

    Promise.all(
      sectionIds.map((sectionId) =>
        fetch(`${window.location.pathname}?section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
      )
    )
      .then((docs) => {
        docs.forEach((html) => {
          replaceBlock('SudathiStealProgress', html);
          replaceBlock('SudathiStealDeals', html);
        });
      })
      .catch((e) => console.error('SudathiSteal: refresh failed', e));
  }

  function renderCartSections(parsedState) {
    if (!parsedState.sections) return false;

    const cart = miniCart();
    if (cart) {
      cart.renderContents(parsedState);
      return true;
    }

    if (!window.location.pathname.includes('/cart')) return false;

    const itemsEl = document.getElementById('main-cart-items');
    const footerEl = document.getElementById('main-cart-footer');
    let updated = false;

    if (itemsEl && itemsEl.dataset.id && parsedState.sections[itemsEl.dataset.id]) {
      const target = itemsEl.querySelector('.js-contents');
      if (target) {
        const html = new DOMParser().parseFromString(parsedState.sections[itemsEl.dataset.id], 'text/html');
        const next = html.querySelector('.js-contents');
        if (next) {
          target.innerHTML = next.innerHTML;
          updated = true;
        }
      }
    }

    if (footerEl && footerEl.dataset.id && parsedState.sections[footerEl.dataset.id]) {
      const html = new DOMParser().parseFromString(parsedState.sections[footerEl.dataset.id], 'text/html');
      replaceBlock('SudathiStealDeals', html);
      updated = true;
    }

    return updated;
  }

  function addSudathiStealItem(variantId, btn) {
    if (!variantId) return;

    const cart = miniCart();
    const sections = getSectionsPayload();

    if (btn) btn.innerHTML = '...';

    fetch(`${theme.routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _steal_deal: 'true' },
        sections,
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status === 422) {
          if (btn) btn.innerHTML = '!';
          return;
        }

        const rendered = renderCartSections(parsedState);
        if (!rendered && window.location.pathname.includes('/cart')) {
          window.location.reload();
        } else if (!rendered) {
          refreshSudathiSteal();
        }

        runStealDiscountSync().then(() => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
        });
      })
      .catch((e) => {
        console.error('SudathiSteal: add failed', e);
        if (btn) btn.innerHTML = '!';
      });
  }

  function updateSudathiStealDiscount(code, btn) {
    const sections = getSectionsPayload();
    if (btn) {
      btn.disabled = true;
      btn.dataset.originalLabel = btn.innerText;
      btn.innerText = '...';
    }

    fetch(`${theme.routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        discount: code || '',
        sections,
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.text())
      .then((responseText) => {
        const parsedState = JSON.parse(responseText);

        if (parsedState.errors || parsedState.description) {
          console.error('SudathiSteal: discount failed', parsedState);
          if (btn) {
            btn.disabled = false;
            btn.innerText = btn.dataset.originalLabel || btn.innerText;
          }
          return;
        }

        if (!renderCartSections(parsedState)) {
          refreshSudathiSteal();
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));
      })
      .catch((e) => {
        console.error('SudathiSteal: discount failed', e);
        if (btn) {
          btn.disabled = false;
          btn.innerText = btn.dataset.originalLabel || btn.innerText;
        }
      });
  }

  function applySudathiSteal(code, btn) {
    if (!code) return;
    updateSudathiStealDiscount(code, btn);
  }

  function removeSudathiSteal(btn) {
    updateSudathiStealDiscount('', btn);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#SudathiStealDeals')) return;

    const addBtn = event.target.closest('.sudathi-add-btn-circle[data-variant-id]');
    if (addBtn) {
      event.preventDefault();
      addSudathiStealItem(addBtn.dataset.variantId, addBtn);
      return;
    }

    const applyBtn = event.target.closest('[data-discount-action="apply"][data-discount-code]');
    if (applyBtn) {
      event.preventDefault();
      applySudathiSteal(applyBtn.dataset.discountCode, applyBtn);
      return;
    }

    const removeBtn = event.target.closest('[data-discount-action="remove"]');
    if (removeBtn) {
      event.preventDefault();
      removeSudathiSteal(removeBtn);
    }
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(runStealDiscountSync, 300);
  });

  document.addEventListener('cartdrawer:opened', () => {
    setTimeout(runStealDiscountSync, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(runStealDiscountSync, 200));
  } else {
    setTimeout(runStealDiscountSync, 200);
  }
})();
